import API from 'services/AUTH_API';

export default function getUuid(inn) {
  return API.request({
    method: 'GET',
    url: '/oauth/certcode',
    params: { inn },
  });
}
